import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useMsal } from '@azure/msal-react';
import { useAdmin } from '../context/AdminContext';
import { formatFecha } from '../utils/fecha';
import { API } from '../config/api';

const MESES = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
const inputStyle = { padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '8px', fontSize: '13px', outline: 'none', boxSizing: 'border-box', background: '#fff', fontFamily: 'Segoe UI, sans-serif' };
const fmt = (n) => (n == null || isNaN(n)) ? '—' : Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const simbolo = (m) => m === 'Dólares' ? '$' : m === 'Euros' ? '€' : '₡';

export default function GastosAprobacion() {
  const isAdmin = useAdmin();
  const { accounts } = useMsal();
  const aprobadoPor = accounts[0]?.name || accounts[0]?.username || null;

  const ahora = new Date();
  const [anio, setAnio] = useState(ahora.getFullYear());
  const [mes, setMes] = useState('');
  const [lista, setLista] = useState([]);
  const [sel, setSel] = useState({});
  const [cargando, setCargando] = useState(true);
  const [procesando, setProcesando] = useState(false);
  const [msg, setMsg] = useState('');

  useEffect(() => { cargar(); }, [anio, mes]);

  const cargar = async () => {
    setCargando(true); setSel({}); setMsg('');
    try {
      const qs = new URLSearchParams({ estado: 'Registrado' });
      if (anio) qs.append('anio', anio);
      if (mes) qs.append('mes', mes);
      const r = await axios.get(`${API}/gastos?${qs.toString()}`);
      setLista(r.data || []);
    } catch (e) { console.error(e); }
    setCargando(false);
  };

  const aprobables = lista.filter(g => !g.sin_monto);
  const seleccionados = Object.keys(sel).filter(k => sel[k]).map(Number);
  const todosSel = aprobables.length > 0 && aprobables.every(g => sel[g.id]);

  const toggleTodos = () => {
    if (todosSel) setSel({});
    else { const n = {}; aprobables.forEach(g => n[g.id] = true); setSel(n); }
  };

  const aprobar = async () => {
    if (!seleccionados.length) return;
    setProcesando(true); setMsg('');
    try {
      const r = await axios.post(`${API}/gastos?action=aprobar-masivo`, { ids: seleccionados, aprobado_por: aprobadoPor });
      const d = r.data;
      let m = `${d.aprobados} gasto(s) aprobado(s).`;
      if (d.omitidos_sin_monto?.length) m += ` ${d.omitidos_sin_monto.length} omitido(s) por estar sin monto.`;
      setMsg(m);
      await cargar();
    } catch (e) { setMsg('Error: ' + (e.response?.data?.error || e.message)); }
    finally { setProcesando(false); }
  };

  if (!isAdmin) {
    return <div style={{ padding: '40px', fontFamily: 'Segoe UI, sans-serif', color: '#888' }}>Solo administradores pueden aprobar gastos.</div>;
  }

  return (
    <div style={{ padding: '24px', fontFamily: 'Segoe UI, sans-serif', maxWidth: '1100px' }}>
      <div style={{ background: '#012E40', borderRadius: '12px', padding: '16px 20px', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ color: '#fff', fontSize: '17px', fontWeight: '700' }}>Aprobacion de gastos</span>
        <button onClick={aprobar} disabled={procesando || !seleccionados.length}
          style={{ padding: '8px 18px', background: seleccionados.length ? '#185FA5' : '#9bb', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: seleccionados.length ? 'pointer' : 'not-allowed', opacity: procesando ? 0.7 : 1 }}>
          {procesando ? 'Aprobando...' : `Aprobar seleccionados (${seleccionados.length})`}
        </button>
      </div>

      <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', alignItems: 'center' }}>
        <select style={inputStyle} value={anio} onChange={e => setAnio(e.target.value)}>
          <option value="">Todos los años</option>
          {[ahora.getFullYear() + 1, ahora.getFullYear(), ahora.getFullYear() - 1, ahora.getFullYear() - 2].map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <select style={inputStyle} value={mes} onChange={e => setMes(e.target.value)}>
          <option value="">Todos los meses</option>
          {MESES.slice(1).map((m, i) => <option key={i + 1} value={i + 1}>{m}</option>)}
        </select>
        <span style={{ fontSize: '12px', color: '#888' }}>{aprobables.length} aprobable(s) de {lista.length} pendiente(s)</span>
      </div>

      {msg && <div style={{ background: '#EAF3DE', border: '1px solid #b8dfc8', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', color: '#3B6D11', marginBottom: '14px' }}>{msg}</div>}

      <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '12px', overflow: 'hidden' }}>
        {cargando ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#888' }}>Cargando...</div>
        ) : lista.length === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#bbb' }}>No hay gastos pendientes de aprobar en este periodo.</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ background: '#f8f9fa' }}>
                <th style={{ padding: '11px 14px', width: '36px' }}><input type="checkbox" checked={todosSel} onChange={toggleTodos} /></th>
                {['Fecha', 'Categoria', 'Detalle', 'Proyecto', 'Monto total'].map(h => (
                  <th key={h} style={{ padding: '11px 14px', textAlign: h === 'Monto total' ? 'right' : 'left', color: '#888', fontWeight: '600', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #eee' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {lista.map(g => (
                <tr key={g.id} style={{ borderBottom: '1px solid #f3f3f3', opacity: g.sin_monto ? 0.6 : 1 }}>
                  <td style={{ padding: '10px 14px', textAlign: 'center' }}>
                    <input type="checkbox" disabled={g.sin_monto} checked={!!sel[g.id]} onChange={e => setSel(s => ({ ...s, [g.id]: e.target.checked }))} />
                  </td>
                  <td style={{ padding: '10px 14px', color: '#555' }}>{formatFecha(g.fecha)}</td>
                  <td style={{ padding: '10px 14px', color: '#1a1a1a', fontWeight: '500' }}>{g.categoria_nombre}{g.subcategoria_nombre ? <span style={{ color: '#999', fontWeight: '400' }}> · {g.subcategoria_nombre}</span> : null}</td>
                  <td style={{ padding: '10px 14px', color: '#555' }}>{g.descripcion || g.proveedor || '—'}</td>
                  <td style={{ padding: '10px 14px', color: '#555' }}>{g.proyecto_codigo || <span style={{ color: '#bbb' }}>Operativo</span>}</td>
                  <td style={{ padding: '10px 14px', textAlign: 'right', fontWeight: '600', color: '#012E40' }}>
                    {g.sin_monto
                      ? <span style={{ background: '#FCEBEB', color: '#A32D2D', padding: '2px 8px', borderRadius: '8px', fontSize: '11px', fontWeight: '600' }}>Sin monto</span>
                      : `${simbolo(g.moneda)}${fmt(g.monto_total)}`}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
